<template>
  <v-flex xs12 sm12 md12 class="" :name="data.field">
    <span v-if="data.type === 'fromto'">{{data.text}}
      <span v-if="curDimension !== null"><span
        v-if="curDimension.name !== '-'"> {{LabelIn}} {{curDimension.name}}</span></span>
      <span v-if="hasAnkerBank && ((abValueStr && abValueStr.length > 0))">({{abValueStr}})</span></span>
    <v-layout align-center justify-space-around row v-if="data.type === 'fromto'">
      <v-flex md5 class="myField">
        <div class="v-input ma-0 v-text-field theme--light" v-if="(mask && data.unit === '2')">
          <div class="v-input__control">
            <div class="v-input__slot" style="height: 20px;">
              <div class="v-text-field__slot"><label class="v-label theme--light"
                                                     style="left: 0px; right: auto; position: absolute;"></label>

                <imask-input
                  v-model="modelFrom"
                  :mask="Number"
                  :scale="2"
                  :min="-100000000"
                  thousandsSeparator="."
                  @keyup="onKeyUp"
                  :placeHolder="labelvon"
                  radix=",">
                </imask-input>
                <div class="v-text-field__suffix">{{suffix}}</div>
              </div>
            </div>
            <div class="v-text-field__details">
              <div class="v-messages theme--light">
                <div class="v-messages__wrapper"></div>
              </div>
            </div>
          </div>
        </div>
        <v-text-field
          v-if="!(mask && data.unit === '2')"
          :suffix="suffix"
          :id="data.field"
          v-model="modelFrom"
          :label="labelvon"
          @keyup="onKeyUp"
          class="ma-0"
          height="20px"
        >
        </v-text-field>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex md5 class="myField">
        <div class="v-input ma-0 v-text-field theme--light" v-if="(mask && data.unit === '2')">
          <div class="v-input__control">
            <div class="v-input__slot" style="height: 20px;">
              <div class="v-text-field__slot"><label class="v-label theme--light"
                                                     style="left: 0px; right: auto; position: absolute;"></label>

                <!-- padFractionalZeros -->
                <imask-input
                  v-model="modelTo"
                  :mask="Number"
                  :scale="2"
                  :min="-100000000"
                  thousandsSeparator="."
                  :placeHolder="labelbis"
                  @keyup="onKeyUp"
                  radix=",">
                </imask-input>
                <div class="v-text-field__suffix">{{suffix}}</div>
              </div>
            </div>
            <div class="v-text-field__details">
              <div class="v-messages theme--light">
                <div class="v-messages__wrapper"></div>
              </div>
            </div>
          </div>
        </div>
        <v-text-field
          v-if="!(mask && data.unit === '2')"
          :id="data.field"
          v-model="modelTo"
          :suffix="suffix"
          :label="labelbis"
          @keyup="onKeyUp"
          class="ma-0"
          height="20px"
        ></v-text-field>
      </v-flex>
      <i aria-hidden="true" @click="onClear()" class="v-icon v-icon--link material-icons">clear</i>
    </v-layout>
    <span v-if="(data.type === 'fromtoprz')" :title="data.przBaseValue">{{data.text}} <span v-if="hasAnkerBank">({{abValueStr}})</span></span>
    <v-layout align-center justify-space-around row v-if="data.type === 'fromtoprz'">
      <v-flex md5 class="myField">
        <v-text-field
          suffix="%"
          :id="data.field"
          v-model="przModel[0]"
          :label="labelvon"
          @keyup="ocKeyUp"
          class="ma-0"
          height="20px"
        ></v-text-field>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex md5 class="myField">
        <v-text-field
          suffix="%"
          :id="data.field"
          v-model="przModel[1]"
          :label="labelbis"
          @keyup="ocKeyUp"
          class="ma-0"
          height="20px"
        ></v-text-field>
      </v-flex>
      <i aria-hidden="true" @click="onClear()" class="v-icon v-icon--link material-icons">clear</i>
    </v-layout>

    <span v-if="((data.type === 'fromtodropdown'))">{{data.text}}</span>
    <span v-if="((data.type === 'fromtodropdown') && ((abValueRaw && abValueRaw.length > 0))) && hasAnkerBank">({{abValueRaw}})</span>
    <v-layout align-center justify-space-around row v-if="((data.type === 'fromtodropdown'))"
              style="padding-bottom: 20px;">
      <br><br>
      <v-flex md5 class="myField">
        <v-autocomplete v-model="modelFrom"
                        :clearable="false"
                        :items="acList"
                        browser-autocomplete="new-password"
                        hide-details
                        single-line
                        item-text="title"
                        item-value="id"
                        @change="onBeforeChange"
                        @input="onChange"
                        :placeHolder="labelvon"
                        class="ma-0"
                        height="20px"
                        chips
                        dense
        >
          <template
            slot="selection"
            slot-scope="{ item, index }"
          >
            <span v-if="index === 0">{{ item.title }}&nbsp;</span>
            <span
              v-if="index === 1"
              class="grey--text caption"
            >&nbsp; (+{{ myModel.length - 1 }})</span>
          </template>
        </v-autocomplete>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex md5 class="myField">
        <v-autocomplete v-model="modelTo"
                        :clearable="false"
                        :items="acList"
                        hide-details
                        browser-autocomplete="new-password"
                        item-text="title"
                        item-value="id"
                        single-line
                        @change="onBeforeChange"
                        @input="onChange"
                        :placeHolder="labelbis"
                        class="ma-0"
                        height="20px"
                        chips
                        dense
        >
          <template
            slot="selection"
            slot-scope="{ item, index }"
          >
            <span v-if="index === 0">{{ item.title }}&nbsp;</span>
            <span
              v-if="index === 1"
              class="grey--text caption"
            >&nbsp; (+{{ myModel.length - 1 }})</span>
          </template>
        </v-autocomplete>
      </v-flex>
      <i aria-hidden="true" @click="onClear()" class="v-icon v-icon--link material-icons">clear</i>
      <br><br>&nbsp;
    </v-layout>
    <v-layout align-center justify-space-around row v-if="((data.type === 'fromto') && (hasAnkerBank) && (data.field !== 'bankscore'))"
              style="padding-bottom: 20px;">
      <br><br>
      <v-flex md5 class="myField">
        <v-text-field
          :id="data.field"
          v-model="przModel[0]"
          hide-details
          suffix="%"
          single-line
          @keyup="onChangePrz"
          class="ma-0"
          height="20px"
        ></v-text-field>
      </v-flex>
      <v-spacer></v-spacer>
      <!--
      <v-spacer></v-spacer>

      <v-flex style="padding-right: 10px;padding-left: 10px;">
        <v-range-slider
          v-model="przModel"
          :max="400"
          :min="0"
          @input="onChangePrz"
          :step="1"
        ></v-range-slider>
      </v-flex>

      <v-spacer></v-spacer>
      -->
      <v-flex md5 class="myField">
        <v-text-field
          :id="data.field"
          v-model="przModel[1]"
          @click:clear="onClearPrz"
          suffix="%"
          hide-details
          @keyup="onChangePrz"
          single-line
          class="ma-0"
          height="20px"
        ></v-text-field>
      </v-flex>
      <div style="width:20px;height:20px;"></div>
      <br><br>&nbsp;
    </v-layout>
    <div class="myField">
      <v-text-field
        :id="data.field"
        v-if="data.type==='textfield'"
        v-model="myModel"
        :rules="getRules(data.field)"
        @click:clear="onClear"
        :clearable="true"
        :label="data.text"
        @keyup="onKeyUp"
        class="ma-0"
        height="20px"
      ></v-text-field>
    </div>
    <v-autocomplete v-if="data.type==='dropdownms'"
                    v-model="myModel"
                    :clearable="true"
                    :items="acList"
                    multiple
                    browser-autocomplete="new-password"
                    item-text="title"
                    item-value="id"
                    @change="onBeforeChange"
                    @input="onChange"
                    :label="data.text"
                    class="ma-0"
                    height="20px"
                    dense
    >
      <template
        slot="selection"
        slot-scope="{ item, index }"
      >
        <span v-if="index === 0">{{ item.title }}&nbsp;</span>
        <span
          v-if="index === 1"
          class="grey--text caption"
        >&nbsp; (+{{ myModel.length - 1 }})</span>
      </template>
    </v-autocomplete>
    <v-autocomplete v-if="data.type==='dropdown'"
                    v-model="myModel"
                    :clearable="true"
                    :items="acList"
                    browser-autocomplete="new-password"
                    item-text="title"
                    item-value="id"
                    @change="onBeforeChange"
                    @input="onChange"
                    :label="data.text"
                    class="ma-0"
                    height="20px"
                    chips
                    dense
    >
      <template
        slot="selection"
        slot-scope="{ item, index }"
      >
        <span v-if="index === 0">{{ item.title }}&nbsp;</span>
        <span
          v-if="index === 1"
          class="grey--text caption"
        >&nbsp; (+{{ myModel.length - 1 }})</span>
      </template>
    </v-autocomplete>
    <v-checkbox
      v-if="data.type === 'checkbox'"
      v-model="myModel"
      @change="onChange"
      :label="data.text"
      class="ma-0"
      height="20px"
    ></v-checkbox>
    <v-card
      v-if="data.field === 'wzcode'"
      class="mx-auto"
      max-width="500"
      flat
    >
      <DialogWZCode @open="onGetWZCodeEntry"></DialogWZCode>
      <!--  <v-dialog v-model="dialogwzcode" scrollable max-width="800px">
          <template v-slot:activator="{ on }">
            <v-btn color="#004884" dark v-on="on" outline block small>{{ 'BUTTON_WZ_CODE_OPEN' | translate}}</v-btn>
          </template>
          <v-card>
            <v-card color="#004884" dark>
              <v-card-title>{{ 'DIALOG_WZ_CODE_TITLE' | translate}}</v-card-title>
            </v-card>
            <v-divider></v-divider>
            <v-card-text style="height: 300px;">
              <v-layout row wrap justify-space-between>
                <v-flex xs12 sm6>
                  <v-select v-model="wzcodeselect"
                            class="ma-2"
                            :label="labelwzcodeselect"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    class="ma-2"
                    v-model="search"
                    :label="labelwzcode"
                    hide-details
                    clearable
                    append-icon="search"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap justify-start>
                <v-treeview
                  active-class="activetree"
                  :active.sync="active"
                  :items="wzcode"
                  :search="search"
                  activatable
                  open-all
                  :filter="filter"
                  :open.sync="open"
                >
                  <template v-slot:prepend="{ item }">
                    <v-icon
                      v-if="item.children"
                      v-text="`mdi-${item.id === 1 ? 'home-variant' : 'folder-network'}`"
                    ></v-icon>
                  </template>
                </v-treeview>
              </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="#004884" outline small class="text-none" @click="dialogwzcode = false">{{ 'BUTT_CANCEL' | translate}}</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="#004884" dark small class="text-none" @click="dialogwzcode = false">{{ 'BUTT_OK' | translate}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>-->
    </v-card>
  </v-flex>


</template>

<script>
  import moment from 'moment'
  import Vue from 'vue'
  import DialogWZCode from "../dialogs/DialogWZCode";
  import {IMaskDirective} from 'vue-imask'
  import {IMaskComponent} from 'vue-imask';

  export default {
    name: 'SItem',
    components: {DialogWZCode, 'imask-input': IMaskComponent},
    props: ['data', 'header', 'eventName', 'abff', 'onDropDownSearch', 'onKeyUpSearch', 'onClearSearch'],
    directives: {
      imask: IMaskDirective
    },
    watch: {
      myModel: function (val) {
        this.data.value = val
      }
    },
    computed: {
      filter() {
        return this.caseSensitive
          ? (item, search, textKey) => item[textKey].indexOf(search) > -1
          : undefined
      }
    },
    data() {
      return {
        dateRule: [
          v => !v || (v && moment(v, 'DD.MM.YYYY',true).isValid()) || Vue.i18n.translate('ERROR_FORMAT_DOES_NOT_MATCHDDMMYYYY'),
        ],
        active: [],
        factor: 1,
        caseSensitive: false,
        labelwzcodeselect: Vue.i18n.translate('LABEL_WZ_CODE_SELECT'),
        labelwzcode: Vue.i18n.translate('LABEL_WZ_CODE'),
        open: [1, 2],
        mask: undefined,
        dialogwzcode: false,
        itemscurrencydimension: [],
        curDimension: null,
        search: '',
        wzcode: [
          {
            id: 1,
            name: 'WZ-Code',
            children: [
              {
                id: 2,
                name: 'Branche 1',
                children: [
                  {
                    id: 201,
                    name: 'Werkstatt 201'
                  },
                  {
                    id: 202,
                    name: 'Werkstatt 202'
                  },
                  {
                    id: 203,
                    name: 'Werkstatt 203'
                  }
                ]
              },
              {
                id: 3,
                name: 'Branche 2',
                children: [
                  {
                    id: 301,
                    name: 'Software 301'
                  },
                  {
                    id: 302,
                    name: 'Software 302'
                  }
                ]
              },
              {
                id: 4,
                name: 'Branche 3',
                children: [
                  {
                    id: 401,
                    name: 'Gastronomie 401'
                  },
                  {
                    id: 402,
                    name: 'Gastronomie 402'
                  },
                  {
                    id: 403,
                    name: 'Gastronomie 402'
                  }
                ]
              }
            ]
          }
        ],
        wzcodeselect: '',
        labelvon: Vue.i18n.translate('LABEL_SITEM_FROM'),
        labelbis: Vue.i18n.translate('LABEL_SITEM_TO'),
        LabelIn: Vue.i18n.translate('LABEL_SITEM_IN'),
        suffix: '',
        modelFrom: '',
        przModel: ['', ''],
        modelTo: '',
        constAllEntry: 123455651,
        region: -1,
        selectErrors: null,
        hasAnkerBank: false,
        myModel: [],
        acList: [],
        allSelected: false,
        allIsClicked: false,
        abValue: '',
        abValueRaw: '',
        abValueStr: 0,
        userIsChangingModel: false
      }
    },
    methods: {
      checkCountryIsInRegionMap(country) {
        for (var index in Vue.prototype.storage.configuration.regionCountryMap) {
          var item = Vue.prototype.storage.configuration.regionCountryMap[index]
          for (var rIndex in this.region) {
            var itemRegion = this.region[rIndex]
            if ((itemRegion === item.regionId) && (country.id === item.countryId) && (country.lanId === window.edoLanguage)) {
              return true
            }
          }
        }
        return false
      },
      getRules(name) {
        if (name === 'balanceDate') {
          return this.dateRule
        }
        return []
      },
      onKeyUp(evt) {
        var cmp = this
        if (this.data.type === 'fromto') {
          this.myModel = this.modelFrom + Vue.prototype.$api.splitChar + this.modelTo
        }
        if (this.data.type === 'fromtodropdown') {
          this.myModel = this.modelFrom + Vue.prototype.$api.splitChar + this.modelTo
        }
        if (this.onKeyUpSearch) {
          cmp.submit()
          return
        } else {
          cmp.doEmitBefore()
          // this.$nextTick(this.doEmit)
        }
        if (evt.code === 'Enter') {
          cmp.submit()
          return
        }
        if (evt.keyCode === 13) {
          cmp.submit()
          return
        }
      },
      doClear() {
        Vue.prototype.$api.debug('doClear', this.data.type)
        if (this.data.type === 'fromtoprz') {
          this.myModel = Vue.prototype.$api.splitChar
          this.modelFrom = ''
          this.modelTo = ''
          this.przModel = ['', '']
          this.onChangePrz()
        } else if (this.data.type === 'fromto') {
          this.myModel = Vue.prototype.$api.splitChar
          this.modelFrom = ''
          this.modelTo = ''
          this.przModel = ['', '']
          this.onChangePrz()
        } else if (this.data.type === 'fromtodropdown') {
          this.myModel = Vue.prototype.$api.splitChar
          this.modelFrom = ''
          this.modelTo = ''
          this.przModel = ['', '']
          this.onChangePrz()
        }
      },
      onClear() {
        var cmp = this
        this.doClear()

        if (this.onClearSearch) {
          cmp.submit()
        }
      },
      onClearPrz() {
        var cmp = this
        Vue.prototype.$api.debug('onClearPrz', this.data.type)
        this.przModel = ['', '']
        this.myModel = this.przModel[0] + Vue.prototype.$api.splitChar + this.przModel[1]
        if (this.onClearSearch) {
          cmp.submit()
        }
      },
      getSelectedCurrency(id) {
        for (var aIndex in this.acList) {
          var item = this.acList[aIndex]
          if (item.id === id) {
            return item
          }
        }
        return null
      },
      onGetWZCodeEntry(wzCode) {
        if (wzCode && wzCode.WZCode) {
          let val = wzCode.WZCode
          while (val.length > 0) {
            let idx = val.lastIndexOf('0')
            if (idx < 0) break;
            if (idx !== val.length - 1) break
            val = val.substr(0, idx)
          }
          this.myModel = val
        }
      },
      refreshI18N() {
        this.reload()
      },
      onGetCurrency(currencyObject) {
        Vue.prototype.$api.debug('onGetCurrency', currencyObject)
        if (currencyObject) {
          this.suffix = currencyObject.title
          Vue.prototype.storage.saveState('currencySuffix', this.suffix)
        }


        if (this.data.unit === '1') {
          this.suffix = '%' // Einheit Prozent
        }
        if (this.data.unit === '2') {
          // this.suffix = '' // Einheit ist monetär
        }
        if (this.data.unit === '3') {
          this.suffix = '' // Ohne Einheit
        }
        if (this.data.unit === '4') {
          this.suffix = '' // Ohne Einheit
        }
        if (this.data.field === 'bankscore') {
          this.suffix = '' // Ohne Einheit
        }
      },
      onBeforeChange(selectedArray) {
        Vue.prototype.$api.debug('onBeforeChange', this.allIsClicked, this)
        if (this.data.field === 'waehrung') {
          var currency = this.getSelectedCurrency(this.myModel)
          Vue.prototype.$eventHub.$emit('selectedCurrencyInMask', currency)
        }
        var aIndex = 0
        var item = {}
        if (this.allSelected) {
          this.allIsClicked = true
          for (aIndex in selectedArray) {
            item = selectedArray[aIndex]
            if (item === this.constAllEntry) {
              this.allIsClicked = false
            }
          }
        } else {
          this.allIsClicked = false
          for (aIndex in selectedArray) {
            item = selectedArray[aIndex]
            if (item === this.constAllEntry) {
              this.allIsClicked = true
            }
          }
        }
        return true
      },
      onABSFromAnkerbankValue(eventData) {
        if (this.data.field !== eventData.field) return
        // console.log('onABSFromAnkerbankValue', eventData)
        var srcSplit = eventData.field.split('|')
        var eventSplit = this.data.field.split('|')
        let f = (1.0 / this.factor)
        if (srcSplit[1] === eventSplit[1]) {
          let x = '' + (Vue.prototype.$api.convertValueToDecimal(eventData.fromValue) * f)
          if (('' + eventData.fromValue).length > 0) {
            this.modelFrom = x.replace(/\./g,',')
          }
          let y = '' + (Vue.prototype.$api.convertValueToDecimal(eventData.toValue) * f)
          if (('' + eventData.toValue).length > 0) {
            this.modelTo = y.replace(/\./g,',')
          }
          if (this.data.type === 'fromto') {
            this.myModel = this.modelFrom + Vue.prototype.$api.splitChar + this.modelTo
          }
        }

      },
      onPRZFromAnkerbankValue(eventData) {
        if (this.data.field !== eventData.field) return
        // console.log('onPRZFromAnkerbankValue', eventData)
        var srcSplit = eventData.field.split('|')
        var eventSplit = this.data.field.split('|')
        if (srcSplit[1] === eventSplit[1]) {
          this.modelFrom = '' + Vue.prototype.$api.convertValueToDecimal(eventData.fromValue)
          this.modelTo = '' + Vue.prototype.$api.convertValueToDecimal(eventData.toValue)
          this.myModel = this.modelFrom + Vue.prototype.$api.splitChar + this.modelTo
        }
      },
      ocKeyUp() {
        this.myModel = this.przModel[0] + Vue.prototype.$api.splitChar + this.przModel[1]
      },
      onChangePrz() {
        let fromBasis = Vue.prototype.$api.convertValueToDecimal(this.przModel[0])
        let toBasis = Vue.prototype.$api.convertValueToDecimal(this.przModel[1])
        this.myModel = fromBasis + Vue.prototype.$api.splitChar + toBasis

        var from = ''
        var to = ''
        if (fromBasis && fromBasis.length) {
          from = (this.abValue * 0.01) * fromBasis // (this.abValue * 0.01) * fromBasis
        }
        if (toBasis && toBasis.length) {
          to = (this.abValue * 0.01) * toBasis
        }

        // console.log('onChangePrz', this.abValue, 'fb' + fromBasis, 'tb' + toBasis, from, to)

        if (this.myModel === Vue.prototype.$api.splitChar) {
          from = ''
          to = ''
        }

        if (isNaN(from)) {
          from = ''
        }
        if (isNaN(to)) {
          to = ''
        }
        if (this.data.type === 'fromto') {
          Vue.prototype.$eventHub.$emit('onABSFromAnkerbankValue', {
            'fromValue': from,
            'toValue': to,
            'field': this.data.field
          })
        } else {
          Vue.prototype.$eventHub.$emit('onPRZFromAnkerbankValue', {
            'fromValue': from,
            'toValue': to,
            'field': this.data.field
          })
        }
      },
      onChange(selectedArray) {
        if (this.userIsChangingModel) return
        if (this.data.type === 'fromtodropdown') {
          this.myModel = this.modelFrom + Vue.prototype.$api.splitChar + this.modelTo
        }
        var cmp = this
        var sa = selectedArray
        this.$nextTick(function () {
          if (this.onDropDownSearch) {
            cmp.doSubmit(sa)
          } else {
            this.doBeforeSubmit(sa)
          }
        })
      },
      doBeforeSubmit(selectedArray) {
        Vue.prototype.$api.debug('doSubmit', this.allIsClicked, this.allSelected)
        if ((this.allIsClicked && this.allSelected)) {
          this.allIsClicked = false
          this.allSelected = false
          this.myModel.splice(0, this.myModel.length)
          return
        }
        if (!this.allIsClicked && this.allSelected) {
          this.myModel.splice(0, 1)
          this.allSelected = false
          return
        }
        this.userIsChangingModel = true
        var selectAll = false
        for (var aIndex in selectedArray) {
          var item = selectedArray[aIndex]
          if (item === this.constAllEntry) {
            selectAll = true
          }
        }
        if (this.allSelected) {
          this.allSelected = false
          selectAll = false
        }
        if (selectAll) {
          this.myModel.splice(0, this.myModel.length)
          for (var i in this.data.itemList) {
            var it = this.data.itemList[i]
            this.myModel.push(it.id)
          }
          this.allSelected = true
        }
        this.userIsChangingModel = false
      },
      doSubmit(selectedArray) {
        this.doBeforeSubmit(selectedArray)
        this.$nextTick(this.submit)
      },
      doEmitBefore() {
        var cmp = this
        if (cmp.data.field === 'balanceSumFromPercent') {
          Vue.prototype.$eventHub.$emit('onPRZFromAnkerbank', cmp.data)
        }
        if (cmp.data.field === 'balanceSumToPercent') {
          Vue.prototype.$eventHub.$emit('onPRZToAnkerbank', cmp.data)
        }
        if (cmp.data.field === 'region') {
          var regionNr = cmp.data.value
          if (cmp.data.value === null) {
            regionNr = -1
          }
          Vue.prototype.$eventHub.$emit('onRegion', regionNr)
        }
      },
      doEmit() {
        Vue.prototype.$api.debug('doEmit')
        var cmp = this
        Vue.prototype.$eventHub.$emit(cmp.eventName, cmp.data)
      },
      submit() {
        Vue.prototype.$api.debug('submit')
        var cmp = this
        this.$nextTick(function () {
          cmp.doEmitBefore()
          cmp.doEmit()
        })
      },
      onOtherSumSelected(data) {
        if (this.data.field === 'balanceSumTo') {
          this.myModel = data.balanceSumTo
          this.data.value = data.balanceSumTo
          if (this.onDropDownSearch) {
            this.submit()
          }
        }
        if (this.data.field === 'balanceSumFrom') {
          this.myModel = data.balanceSumFrom
          this.data.value = data.balanceSumFrom
          if (this.onDropDownSearch) {
            this.submit()
          }
        }
      },
      clearAllSearchFields() {
        this.doClear()
      },
      onOtherYearSelected(data) {
        if (this.data.field === 'year') {
          this.myModel = data
          this.data.value = data
          if (this.onDropDownSearch) {
            this.submit()
          }
        }
      },
      onOtherCurrencySelected(data) {
        if (this.data.field === 'waehrung') {
          this.myModel = data
          this.data.value = data
          if (this.onDropDownSearch) {
            this.submit()
          }
        }
      },
      onOtherRechtskreisSelected(data) {
        if (this.data.field === 'rechtskreis') {
          this.myModel = data
          this.data.value = data
          if (this.onDropDownSearch) {
            this.submit()
          }
        }
      },
      onRegion(regionNr) {
        if (this.data.field === 'country') {
          Vue.prototype.$api.debug('onRegion', regionNr)
          this.region = regionNr
          this.changeRegionList()
        }
      },
      onUpdateallSearchFields(data) {
        if (data === null) {
          this.myModel = null
          this.data.value = null
          return
        }
        var value = data[this.data.field]
        // console.log('updateAllSearchFields', data, this.data)
        if (data.searchData) {
          let f = (1.0 / this.factor)
          var fa = data.searchData.filter.split(',')
          // console.log('filters', fa)
          for (var index in fa) {
            var v = fa[index]
            var arr = v.split(':')
            // console.log('arr', arr)
            if (this.data.field === arr[1]) {
              if (arr[2].indexOf('|') > -1) {
                let valueList = arr[2].split('|')
                value = valueList
              } else {
                if (arr.length === 3) {
                  value = arr[2]
                } else if (arr.length === 4) {
                  this.modelFrom = '' + arr[2] * f
                  this.modelTo = '' + arr[3] * f
                  value = '' + this.modelFrom + Vue.prototype.$api.splitChar + this.modelTo
                }
              }
            }
          }
        } else {
          // console.log('missing filter', data)
          var values = null
          if (value) {
            if (this.data.field.startsWith('abs')) {
              values = value.split(Vue.prototype.$api.splitChar)
              this.modelFrom = values[0]
              this.modelTo = values[1]
            } else if (this.data.field.startsWith('prz')) {
              values = value.split(Vue.prototype.$api.splitChar)
              this.przModel = values
            }
          }
        }
        if (value) {
          this.myModel = value
          this.data.value = value
        } else {
          this.myModel = null
          this.data.value = null
        }
      }
      ,
      reload() {
        let cmp = this
        this.myModel = this.data.value
        this.hasAnkerBank = Vue.prototype.storage.isAnkerbank(Vue.prototype.$api.getModuleId())
        this.suffix = Vue.prototype.storage.getStorage('currencySuffix', '€')
        this.itemscurrencydimension = Vue.prototype.storage.getCurrencyDimensionList()

        if (this.data.unit === '1') {
          this.suffix = '%' // Einheit Prozent
        }
        if (this.data.unit === '2') {
          // this.suffix = '' // Einheit ist monetär
        }
        if (this.data.unit === '3') {
          this.suffix = '' // Ohne Einheit
        }
        if (this.data.unit === '4') {
          this.suffix = '' // Ohne Einheit
        }
        if (this.data.field === 'bankscore') {
          this.suffix = '' // Ohne Einheit
        }
        let curIndex = _.findIndex(this.itemscurrencydimension, function (o) {
          return o.id === cmp.data.dimension
        })
        if (curIndex > -1) {
          this.curDimension = this.itemscurrencydimension[curIndex]
          this.mask = {
            mask: '',
            radix: '.',
            lazy: true
          }
          if (this.curDimension !== null) {
            this.factor = this.curDimension.factor
          }
        }
        if (this.data.itemList) {
          var x = {
            id: 123455651,
            lanId: 123455651,
            title: Vue.i18n.translate('LABEL_DD_ALL')
          }
          var doAdd = true
          if (this.data.type === 'dropdown') {
            doAdd = false
          }
          if (this.data.itemList.length > 0) {
            if (this.data.itemList[0].id === 123455651) {
              doAdd = false
            }
          }
          if (doAdd) {
            this.data.itemList.unshift(x)
          }
        }
        if (this.data.field === 'country') {
          this.changeRegionList()
        } else {
          if (this.data.itemList) {
            this.acList = this.data.itemList
          }
        }
        this.abValue = this.data.abValue
        this.abValueRaw = this.data.abValue
        if (!Number.isFinite(this.data.abValue) && (this.data.abValue)) {
          var maximumFractionDigits = 0
          var minimumFractionDigits = 0
          this.abValueStr = (1 * this.data.abValue).toLocaleString('de-DE', {
            style: 'decimal',
            useGrouping: true,
            maximumFractionDigits: maximumFractionDigits,
            minimumFractionDigits: minimumFractionDigits
          })
        } else {
          this.abValueStr = ''
        }
        if (!this.data.isStandard) {
          var values = []
          if (this.data.type === 'fromtoprz') {
            if (!this.data.value) {
              this.data.value = Vue.prototype.$api.splitChar
              this.myModel = Vue.prototype.$api.splitChar
              this.modelFrom = ''
              this.modelTo = ''
              this.przModel = ['', '']
            } else {
              values = this.data.value.split(Vue.prototype.$api.splitChar)
              this.modelFrom = values[0]
              this.modelTo = values[1]
              this.myModel = this.modelFrom + Vue.prototype.$api.splitChar + this.modelTo
              // values[0] = 100 / this.abValue * values[0]
              // values[1] = 100 / this.abValue * values[1]
              this.przModel = values
            }
          } else if (this.data.type === 'fromto') {
            if (!this.data.value) {
              this.data.value = Vue.prototype.$api.splitChar
              this.myModel = Vue.prototype.$api.splitChar
              this.modelFrom = ''
              this.modelTo = ''
              this.przModel = ['', '']
            } else {
              values = this.data.value.split(Vue.prototype.$api.splitChar)
              this.modelFrom = values[0]
              this.modelTo = values[1]
              this.myModel = this.modelFrom + Vue.prototype.$api.splitChar + this.modelTo
              values[0] = 100 / this.abValue * values[0]
              values[1] = 100 / this.abValue * values[1]
              this.przModel = values
            }
          }
        }
        /*
        if (Vue.prototype.storage.abFilterFields) {
          var itemField = this.data.field.split('|')
          var key = itemField[1] + '_' + itemField[2]
          Vue.prototype.storage.abFilterFields[key]
        }
        */
      }
      ,
      changeRegionList() {
        if ((!this.region) || (this.region === -1) || (this.region.length === 0)) {
          // Vue.prototype.$api.debug('no region filter')
          this.acList = this.data.itemList
        } else {
          Vue.prototype.$api.debug('region filter is active', this.data.itemList.length)
          var countryList = []
          for (var index in this.data.itemList) {
            var item = this.data.itemList[index]
            if (this.checkCountryIsInRegionMap(item)) {
              countryList.push((item))
            }
          }
          Vue.prototype.$api.debug('region filter is active', countryList.length)
          var tempList = []
          tempList.push.apply(tempList, countryList)
          var x = {
            id: 123455651,
            lanId: 123455651,
            title: Vue.i18n.translate('LABEL_DD_ALL')
          }
          tempList.unshift(x)
          this.acList = tempList
        }
      }
    },
    created() {
      Vue.prototype.$eventHub.$on('onRegion', this.onRegion)
      Vue.prototype.$eventHub.$on('otherYearSelected', this.onOtherYearSelected)
      Vue.prototype.$eventHub.$on('otherRechtskreisSelected', this.onOtherRechtskreisSelected)
      Vue.prototype.$eventHub.$on('otherCurrencySelected', this.onOtherCurrencySelected)
      Vue.prototype.$eventHub.$on('otherSumSelected', this.onOtherSumSelected)
      Vue.prototype.$eventHub.$on('updateAllSearchFields', this.onUpdateallSearchFields)
      Vue.prototype.$eventHub.$on('clearAllSearchFields', this.clearAllSearchFields)
      Vue.prototype.$eventHub.$on('onPRZFromAnkerbankValue', this.onPRZFromAnkerbankValue)
      Vue.prototype.$eventHub.$on('onABSFromAnkerbankValue', this.onABSFromAnkerbankValue)
      Vue.prototype.$eventHub.$on('selectedCurrencyInMask', this.onGetCurrency)
      Vue.prototype.$eventHub.$on('I18NIsRefresh', this.refreshI18N)
    },
    destroyed() {
      Vue.prototype.$eventHub.$off('onRegion', this.onRegion)
      Vue.prototype.$eventHub.$off('otherRechtskreisSelected', this.onOtherRechtskreisSelected)
      Vue.prototype.$eventHub.$off('otherCurrencySelected', this.onOtherCurrencySelected)
      Vue.prototype.$eventHub.$off('otherYearSelected', this.onOtherYearSelected)
      Vue.prototype.$eventHub.$off('otherSumSelected', this.onOtherSumSelected)
      Vue.prototype.$eventHub.$off('updateAllSearchFields', this.onUpdateallSearchFields)
      Vue.prototype.$eventHub.$off('clearAllSearchFields', this.clearAllSearchFields)
      Vue.prototype.$eventHub.$off('onPRZFromAnkerbankValue', this.onPRZFromAnkerbankValue)
      Vue.prototype.$eventHub.$off('onABSFromAnkerbankValue', this.onABSFromAnkerbankValue)
      Vue.prototype.$eventHub.$off('selectedCurrencyInMask', this.onGetCurrency)
      Vue.prototype.$eventHub.$off('I18NIsRefresh', this.refreshI18N)
    },
    mounted() {
      this.wait = true
      this.reload()
      if (this.LabelIn === 'LABEL_SITEM_IN') this.LabelIn = 'in'
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/module/mask/SItem.vue